import { get, pipe } from "../../utils"
import { createRequestTypes, action, requestTypes } from "../utils"

export const FETCH_SEARCH = createRequestTypes("FETCH_SEARCH")

export const actionTypes = {
  LOAD_INITIAL_DATA: "LOAD_INITIAL_DATA",
  UPDATE_SEARCH_QUERY: "UPDATE_SEARCH_QUERY",
  UPDATE_NAV_SEARCH_QUERY: "UPDATE_NAV_SEARCH_QUERY",
  CHANGE_PAGE: "CHANGE_PAGE",
  REQUEST_PAGE: "REQUEST_PAGE",
  FETCH_SEARCH
}

const getSiteSearch = get("search")
const getPages = pipe(getSiteSearch, get("pages"))
const getSiteStatus = pipe(getSiteSearch, get("status"))
const getNavSearchQuery = pipe(getSiteStatus, get("navQuery"))
const getQuery = pipe(getSiteStatus, get("query"))
const getSearchResults = pipe(getSiteStatus, get("results"))
const getCurrentPage = pipe(getSiteStatus, get("currentPage"))
const getPageCount = pipe(getSiteStatus, get("totalPage"))
const getResultsPerPage = pipe(getSiteStatus, get("resultsPerPage"))
const getPage = page => (state) => {
  const pages = getPages(state)
  return pages[page]
}
const getCurrentPageData = (state) => {
  const currentPage = getCurrentPage(state)
  return getPage(currentPage)(state)
}
const getPageResults = page => state => get("results", getPage(page)(state))

const getResults = state => get("results", getPageResults(state))

export const selectors = {
  getSiteStatus,
  getSearchResults,
  getNavSearchQuery,
  getQuery,
  getCurrentPage,
  getPageCount,
  getResultsPerPage,
  getCurrentPageData,
  getPage,
  getPageResults,
  getResults
}

const fetchSearch = {
  request: (page, query) => action(FETCH_SEARCH[requestTypes.REQUEST], { page, query }),
  success: (page, data) => action(FETCH_SEARCH[requestTypes.SUCCESS], { page, ...data }),
  failure: (page, error) => action(FETCH_SEARCH[requestTypes.FAILURE], { page, error })
}

const loadInitialData = query => ({
  type: actionTypes.LOAD_INITIAL_DATA,
  payload: query
})

const updateNavSearchQuery = query => ({
  type: actionTypes.UPDATE_NAV_SEARCH_QUERY,
  payload: query
})

const updateSearchQuery = query => ({
  type: actionTypes.UPDATE_SEARCH_QUERY,
  payload: query
})

const changePage = page => ({
  type: actionTypes.CHANGE_PAGE,
  payload: page
})

const requestPage = page => ({
  type: actionTypes.REQUEST_PAGE,
  payload: page
})

export const actionCreators = {
  loadInitialData,
  updateNavSearchQuery,
  updateSearchQuery,
  changePage,
  requestPage,
  fetchSearch
}



// WEBPACK FOOTER //
// ./src/store/actions/search.js